/* !
 * setting.js v1.0.0
 * Copyright, Connecty Inc.
 */
(() => {
	const siteName = 'default-package';
	const htmlHasClass = (_class) => { return document.documentElement.classList.contains(_class); };
	const a = 'is-active';
	const v = 'is-visible';
	const f = 'is-fixed';

	FUNCTIONS = {
		va: {
			pathname: location.pathname,
			isMobile: htmlHasClass('ua-mobile'),
			device: {
				desktop: 1024,
				sp: 768
			},
			window: {
				width: window.innerWidth,
				height: window.innerHeight
			},
			header: {
				desktop: 100,
				sp: 60
			}
		},
		localDecision() {
			const regExp = new RegExp(`(test\\.${siteName}\\.connecty\\.co\\.jp|copre\\.jp|localhost|192\\.168\\.|100\\.64\\.)`, 'g');
			return regExp.test(location.hostname);
		},
		localLoading() { // ローカル環境ならincludeをAjaxで読み込む
			const _this = this;
			const key = 'inc_';
			let ajaxArray = [];
			let ajaxArrayList = [];
			let includeClass = document.querySelectorAll(`[class*="${key}"]`);

			includeClass.forEach(ele => {
				let path = ele.innerHTML.split(' ')[1];
				ajaxArray.push(path);
			});

			if (ajaxArray.length) {
				ajaxArray.forEach(ele => {
					let xhr = new XMLHttpRequest();
					let promise = new Promise((resolve, reject) => {
						xhr.onreadystatechange = function () {
							if (xhr.readyState === 4) {
								if (xhr.status === 200) {
									resolve(xhr.responseText);
								} else {
									reject(xhr.statusText);
								}
							}
						};
					});
					xhr.open('GET', ele + '.html', true);
					xhr.send();
					ajaxArrayList.push(promise);
				});

				Promise.all(ajaxArrayList).then(results => {
					let regExp = new RegExp(key);

					results.forEach(ele => {
						let classList = ele.split(/ |\"/g);
						let position;

						classList.forEach(ele2 => {
							if (ele2.match(regExp)) { position = ele2; }
						});
						document.querySelectorAll('.' + position).forEach(ele2 => {
							ele2.outerHTML = ele;
						});
						console.log('Succeeded to read the include file!:', position);
					});

					// 置換完了時にカスタムイベントを発火
					document.dispatchEvent(new Event('localincludeLoaded'));

					_this.loadDelayScript();
				}).catch((error) => {
					console.error('Failed to read the include file:', error);

					document.dispatchEvent(new Event('localincludeLoaded'));
					_this.loadDelayScript();
				});
			} else {
				document.dispatchEvent(new Event('localincludeLoaded'));
				_this.loadDelayScript();
			}
		},
		getQuery() {
			let vars = [];
			let hash = null;
			let hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
			hashes.forEach(ele => {
				hash = ele.split('=');
				hash[1] = (hash[1].indexOf('#') !== -1) ? hash[1].split('#')[0] : hash[1];
				vars.push(hash[0]);
				vars[hash[0]] = hash[1];
			});
			return vars;
		},
		accordion() {
			const details = document.querySelectorAll('.js-accordion');

			details.forEach(ele => {
				const summary = ele.querySelector('summary');
				const wrapper = ele.querySelector('.mod-accordion-wrapper');
				const plus = ele.querySelector('.mod-accordion-plus');
				const isPC = FUNCTIONS.va.window.width > FUNCTIONS.va.device.sp;
				const isPCOnly = ele.dataset.open === 'pc';
				if (ele.open) {
					const close = wrapper.animate(
						{
							opacity: [1, 0],
							height: [wrapper.offsetHeight + 'px', 0],
						},
						{
							duration: 300,
							easing: 'ease',
						}
					);
					plus.animate(
						{ rotate: ['0deg', '90deg'] },
						{
							duration: 300,
							pseudoElement: "::after",
							easing: 'ease',
							fill: 'forwards',
						}
					);
					if (isPCOnly) {
						if (isPC) {
							ele.setAttribute('open', 'true');
							wrapper.animate(
								{
									opacity: [0, 1],
									height: [0, wrapper.offsetHeight + 'px']
								},
								{
									duration: 300,
									easing: 'ease'
								}
							);
							plus.animate(
								{ rotate: ['0deg', '90deg'] },
								{
									duration: 300,
									pseudoElement: "::after",
									easing: 'ease',
									fill: 'forwards',
								}
							);
						} else {
						ele.removeAttribute('open');
						plus.animate(
							{ rotate: ['90deg', '0deg'] },
							{
								duration: 300,
								pseudoElement: "::after",
								easing: 'ease',
								fill: 'forwards',
							}
						);
					}
						
					}
				}

				summary.addEventListener('click', e => {
					e.preventDefault();
					if (ele.open) {
						const close = wrapper.animate(
							{
								opacity: [1, 0],
								height: [wrapper.offsetHeight + 'px', 0],
							},
							{
								duration: 300,
								easing: 'ease',
							}
						);
						plus.animate(
							{ rotate: ['90deg', '0deg'] },
							{
								duration: 300,
								pseudoElement: "::after",
								easing: 'ease',
								fill: 'forwards',
							}
						);
						close.onfinish = () => {
							ele.removeAttribute('open');
						}
					} else {
						ele.setAttribute('open', 'true');
						wrapper.animate(
							{
								opacity: [0, 1],
								height: [0, wrapper.offsetHeight + 'px'],
							},
							{
								duration: 300,
								easing: 'ease',
							}
						);
						plus.animate(
							{ rotate: ['0deg', '90deg'] },
							{
								duration: 300,
								pseudoElement: "::after",
								easing: 'ease',
								fill: 'forwards',
							}
						);
					}
				});
			});
		},
		tabSwitch() {
			let $tab = document.querySelectorAll('.js-tab');
			let $content = document.querySelectorAll('.js-tab-content');
			if ($tab.length) {
				// ハッシュタグで絞り込み
				if (location.hash) {
					let hash = location.hash.split('#')[1];
					$tab.forEach(ele => {
						ele.classList.remove(a);
						if (ele.getAttribute('data-target').match(hash)) {
							ele.classList.remove(a);
						}
					});
					$content.forEach(ele => {
						ele.classList.remove(a);
						ele.classList.remove(v);
						if (ele.getAttribute('data-target').match(hash)) {
							$(ele).addClass(a);
							setTimeout(() => { ele.classList.add(v); }, 200);
						}
					});
				}

				$tab.forEach(ele => {
					ele.addEventListener('click', () => {
						$tab.forEach(ele2 => { ele2.classList.remove(a); })
						ele.classList.add(a);
						$content.forEach(ele => {
							ele.classList.remove(a);
							ele.classList.remove(v);
						});

						let $target;
						let target = ele.getAttribute('data-target');
						if (target === 'all') {
							$target = $content;
						} else {
							$target = document.querySelectorAll('[data-target="' + target + '"]');
						}
						$target.forEach(ele => {
							ele.classList.add(a);
							setTimeout(() => { ele.classList.add(v); }, 200);
						});
					});
				});
			}
		},
		easeScroll() {
			const scrollToObject = (_self) => {
				let hash = _self.currentTarget.href.split('#')[1];
				let pos = hash === 'pagetop' ? 0 : document.getElementById(hash).getBoundingClientRect().top;
				let offset = hash === 'pagetop' ? 0 : window.scrollY;
				pos += offset;

				if (hash !== 'pagetop') {
					if (FUNCTIONS.va.window.width < FUNCTIONS.va.device.sp) {
						pos = pos - FUNCTIONS.va.header.sp;
					} else {
						pos = pos - FUNCTIONS.va.header.desktop;
					}
				}
				window.scrollTo({ top: pos, behavior: 'smooth' });
			}
			// フォーカス用関数
			const scrollFocus = (_hash) => {
				let hash = _hash;
				if (hash !== 'pagetop') {
					const focusableElementsSelector = 'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, [tabindex="0"], [contenteditable]';
					const focusableElements = Array.from(
						document.getElementById(hash).querySelectorAll(focusableElementsSelector)
					);
					if(focusableElements.length) {
						focusableElements[0].focus({ preventScroll: true });
					}
				}
			};
			// スクロール完了後に実行する関数
			let scrollResolveTimeout;
			const waitForScrollComplete = (_hash) => {
			  return new Promise((resolve) => {
				const scrollTimeout = setTimeout(() => {
				  resolve(true);
				}, 100);
				const scrollTimeoutEvent = addEventListener('scroll', function fn (e) {
					clearTimeout(scrollTimeout);
					clearTimeout(scrollResolveTimeout);
					scrollResolveTimeout = setTimeout(function () {
						scrollFocus(_hash);
						removeEventListener('scroll', fn);
						resolve(true);
					}, 100);
				});
			  });
			};
			document.querySelectorAll('a[rel="scroll"]').forEach((ele) => {
				ele.addEventListener('click', async (e) => {
					e.preventDefault();
					if (/#/.test(e.currentTarget.href)) {
						scrollToObject(e);
						let hash = e.currentTarget.href.split('#')[1];
						await waitForScrollComplete(hash);
						return false;
					}
				});
			});
		},
		easeScrollHash() {
			const hash = location.hash;
			if (hash) {
				// フォーカス用関数
				const scrollFocus = (_hash) => {
					let hash = _hash;
					if (hash !== 'pagetop') {
						const focusableElementsSelector = 'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, [tabindex="0"], [contenteditable]';
						const focusableElements = Array.from(
							document.getElementById(hash).querySelectorAll(focusableElementsSelector)
						);
						if(focusableElements.length) {
							focusableElements[0].focus();
						}
					}
				}
				// スクロール完了後に実行する関数
				let scrollResolveTimeout;
				const waitForScrollComplete = (_hash) => {
					return new Promise((resolve) => {
						const scrollTimeout = setTimeout(() => {
						resolve(true);
						}, 100);
						const scrollTimeoutEvent = addEventListener('scroll', function fn (e) {
							clearTimeout(scrollTimeout);
							clearTimeout(scrollResolveTimeout);
							scrollResolveTimeout = setTimeout(function () {
								scrollFocus(_hash);
								removeEventListener('scroll', fn);
								resolve(true);
							}, 100);
						});
					});
				}
				window.addEventListener('load', async () => {
					document.documentElement.style.display = 'none';
					document.body.style.display = 'none';

					setTimeout(() => {
						document.documentElement.style.display = 'block';
						document.body.style.display = 'block';

						let pos = document.getElementById(hash.split('#')[1]).getBoundingClientRect().top;

						if (FUNCTIONS.va.window.width < FUNCTIONS.va.device.sp) {
							pos -= FUNCTIONS.va.header.sp;
						} else {
							pos -= FUNCTIONS.va.header.desktop;
						}
						window.scrollTo({ top: pos, behavior: 'smooth' });
					}, 100);
					await waitForScrollComplete(hash);
				});
			}
		},
		pageTop() {
			let footer = document.querySelector('.footer');
			let $pagetop = document.querySelector('.footer-pagetop');

			if ($pagetop) {
				window.addEventListener('scroll', (e) => {
					if (window.scrollY > '100') {
						$pagetop.classList.add(v);
					} else {
						$pagetop.classList.remove(v);
					}
				});
			}
		},
		setModal() {
			const createModal = (_appendHTML,_target) => {
				const $container = document.createElement('div');
				$container.className = 'mod-modal-overlay';
				$container.innerHTML = _appendHTML;
				document.body.appendChild($container);

				$container.classList.add(a);
				setTimeout(() => {
					$container.classList.add(v);
					document.querySelectorAll('.mod-modal-closeArea, .mod-modal-closeBtn, .mod-modalContent a').forEach((ele) => {
						ele.addEventListener('click', (e) => {
							$container.classList.remove(v);
							setTimeout(() => {
								$container.classList.remove(a);
								$container.remove();
								_target.focus();
							}, 400);
						});
					});
					window.addEventListener("keydown", function (event) {
						if(document.querySelectorAll('.mod-modal-overlay').length) {
							// タブキーが押された時
							if (event.key === "Tab") {
								event.preventDefault();
								// モーダル要素内のフォーカス可能な要素の一覧を取得
								const focusableElementsSelector = 'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, [tabindex="0"], [contenteditable]';
								const focusableElements = Array.from(
								document.querySelector('.mod-modal-overlay').querySelectorAll(focusableElementsSelector)
								);
								// 現在のフォーカス位置を取得
								const focusedItemIndex = focusableElements.indexOf(document.activeElement);
								// shiftキーと同時に押されてた場合
								if (event.shiftKey) {
								if (focusedItemIndex === 0) {
									// 現在のフォーカスが最初の要素の場合、最後の要素にフォーカスを移動
									focusableElements[focusableElements.length - 1].focus();
								} else {
									// 現在のフォーカスが最初の要素以外の場合、前の要素にフォーカスを移動
									focusableElements[focusedItemIndex - 1].focus();
								}
								} else {
								if (focusedItemIndex === focusableElements.length - 1) {
									// 現在のフォーカスが最後の要素の場合、最初の要素にフォーカスを移動
									focusableElements[0].focus();
								} else {
									// 現在のフォーカスが最後の要素以外の場合、次の要素にフォーカスを移動
									focusableElements[focusedItemIndex + 1].focus();
								}
								}
							}
							// ESCキーが押された時
							if (event.key === "Escape") {
								event.preventDefault();
								$container.classList.remove(v);
								setTimeout(() => {
									$container.classList.remove(a);
									$container.remove();
									_target.focus();
								}, 400);
							}
						}
					});
				});
			};
			document.querySelectorAll('.mod-modal').forEach((ele) => {
				ele.addEventListener('click', (e) => {
					let targetKey = e.currentTarget.getAttribute('data-target');
					let $content = document.querySelector(`.mod-modalContent[data-target="${targetKey}"]`);
					if ($content) {
						let closeButton = document.createElement('button');
						closeButton.setAttribute('type', 'button');
						closeButton.className = 'mod-modal-closeBtn';
						closeButton.setAttribute('aria-label', 'close');
						closeButton.innerHTML = '<span aria-hidden="true"></span>';

						$content.appendChild(closeButton);

						let closeArea = document.createElement('div');
						closeArea.className = 'mod-modal-closeArea';
						let containerDiv = document.createElement('div');
						containerDiv.appendChild(closeArea);
						containerDiv.appendChild($content.cloneNode(true));

						createModal(containerDiv.innerHTML, e.currentTarget);
					}
					return false;
				});
			});

			// 画像1個だけのモーダル
			document.querySelectorAll('.mod-modalImg').forEach((ele) => {
				ele.addEventListener('click', (e) => {
					let appendHTML = `<div class="mod-modal-closeArea"></div>
						<button type="button" class="mod-modal-closeBtn" aria-label="close"><span aria-hidden="true"></span></button>
						${e.currentTarget.querySelector('img').outerHTML}`;
					createModal(appendHTML,e.currentTarget);
					return false;
				});
			});
		},
		matchHeight() {
			const $elements = document.querySelectorAll('[data-mh]');
			const groups = new Map();

			$elements.forEach( ele => { ele.style.height = 'auto'; } ); // 初期化

			$elements.forEach( ele => {
				const attributeName = ele.getAttribute('data-mh');
				if ( !groups.has( attributeName ) ) {
					groups.set( attributeName, [] );
				}
				groups.get( attributeName ).push( ele );
			} );
			groups.forEach( group => {
				const attributeGroups = new Map();
				group.forEach( ele => {
					const attributeName = ele.getAttribute('data-mh');
					const topPosition = ele.getBoundingClientRect().top;
					const key = attributeName + '_' + topPosition;
					if ( !attributeGroups.has( key ) ) {
						attributeGroups.set( key, [] );
					}
					attributeGroups.get( key ).push( ele );
				} );
				attributeGroups.forEach( (item) => {
					const maxHeight = Math.max( ...item.map( ele => ele.offsetHeight ) );
					item.forEach( (ele2) => {
						ele2.style.height = `${maxHeight}px`;
					});
				});
			} );
		},
		inViewAnimation() {
			const target = document.querySelectorAll('.js-fade');
			const options = {
				root: null,
				rootMargin: '-30% 0px',
				threshold: 0
			};
			const callback = (entries, observer) => {
				entries.forEach(entry => {
					if (entry.isIntersecting) {
						entry.target.classList.add(v);
					}
				});
			};
			const observer = new IntersectionObserver(callback, options);

			target.forEach(ele => {
				observer.observe(ele);
			});
		},
		fileSize() {
			const bytesToSize = (bytes) => {
				var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
				if (bytes === 0) {
					return 'n/a';
				}
				var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)), 10);
				if (i === 0) {
					return bytes + ' ' + sizes[i];
				}
				return (bytes / Math.pow(1024, i)).toFixed(1) + ' ' + sizes[i];
			}
			if(document.querySelectorAll('.js-fileSize').length) {
				document.querySelectorAll('.js-fileSize').forEach(function (pdfElement) {
					pdfElement.textContent = bytesToSize(pdfElement.textContent);
				});
			}
		},
		removeElmIfEmpty() {
			// ＜ルート設定対応＞要素が空だったら削除
			const $eleList = document.querySelectorAll('.js-checkEmptyElm');
			$eleList.forEach(ele => {
				if (!ele.textContent.length) {
					ele.remove();
				}
			});
		},
		removeBlockIfListEmpty () {
			// ＜ルート設定対応＞該当のリストにルート設定出力が0件の場合、指定する親ブロックごと削除する
			const $eleList = document.querySelectorAll('.js-checkEmptyList');
			if ($eleList) {
				$eleList.forEach(ele => {
					if (!ele.getElementsByTagName('li').length) {
						ele.closest('.js-checkEmptyList-wrap').remove();
					}
				});
			}
		},
		URLcurrent() {
			if (document.querySelector('.js-current')) {
				document.querySelectorAll('.js-current').forEach(item1 => {
					// 各要素の href を取得し、現在のページのURLに基づいた絶対パスに変換
					const linkPath = new URL(item1.getAttribute('href'), location.origin).pathname.replace(/index\.html$/, '');
					const currentPath = location.pathname.replace(/index\.html$/, '');
					// 現在のページのパスがリンクのパスで始まる場合、is-activeを追加
					if (currentPath == linkPath) {
						item1.classList.add(a);
					}
				});
			}
		},
		URLcurrentHidden() {
			if (document.querySelector('.js-currentHidden')) {
				document.querySelectorAll('.js-currentHidden').forEach(item1 => {
					// 各要素の href を取得し、現在のページのURLに基づいた絶対パスに変換
					const linkPath = new URL(item1.getAttribute('href'), location.origin).pathname.replace(/index\.html$/, '');
					const currentPath = location.pathname.replace(/index\.html$/, '');
					// 現在のページのパスがリンクのパスで始まる場合、親要素のjs-currentHiddenWrapにdi_noneを追加
					if (currentPath == linkPath) {
						const parentWrap = item1.closest('.js-currentHiddenWrap');
						parentWrap.remove();
					}
				});
			}
		},
		headerHamburger(){
			if (document.querySelectorAll('.js-header-hamburger').length) {
				const $header = document.querySelector('.headerRn') || document.querySelector('.header');
				const $hamburger = document.querySelector('.js-header-hamburger');
				const $hamburgerText = $hamburger.querySelector('.headerRn-hamburger-text');
				const $nav = document.querySelector('.js-header-nav-menu');
				const $container = document.querySelector('.container');
				let scrollTopNow = 0;

				const fixedOnContainer = () => {
					scrollTopNow = window.scrollY;
					if ($container) {
						$container.style.position = 'fixed';
						$container.style.width = '100%';
						$container.style.top = -1 * scrollTopNow + 'px';
						$container.style.left = 0;
					} else {
						document.body.classList.add('is-fixed');
						document.body.style.position = 'fixed';
						document.body.style.width = '100%';
						document.body.style.top = -1 * scrollTopNow + 'px';
						document.body.style.left = '0';
					}
				};
				const fixedOffContainer = () => {
					if ($container) {
						$container.style.position = 'static';
						window.scrollTo({ top: scrollTopNow });
					} else {
						document.body.classList.remove('is-fixed');
						document.body.style.position = '';
						document.body.style.width = '';
						document.body.style.top = '';
						document.body.style.left = '';
						window.scrollTo({ top: scrollTopNow });
					}
				};
				const setAria = (open) => {
					$hamburger.setAttribute('aria-expanded', open ? 'true' : 'false');
					$hamburger.ariaLabel = open ? 'close' : 'open';
				};

				$hamburger.addEventListener('click', () => {
					const willOpen = !$nav.classList.contains(a);
					if (willOpen) {
						fixedOnContainer();
						$nav.classList.add(a);
						$hamburger.classList.add(a);
						$hamburgerText.textContent = "閉じる";
					} else {
						$nav.classList.remove(a);
						$hamburger.classList.remove(a);
						fixedOffContainer();
						$hamburgerText.textContent = "メニュー";
					}
					setAria(willOpen);
				});

				// ナビ内リンククリック時はSPでクローズ
				$nav.querySelectorAll('a[href]').forEach((link) => {
					link.addEventListener('click', () => {
						if (window.innerWidth <= 1024 && $nav.classList.contains(a)) {
							$nav.classList.remove(a);
							$hamburger.classList.remove(a);
							setAria(false);
							fixedOffContainer();
							$hamburger.focus({ preventScroll: true });
						}
					});
				});

				// 明示的なクローズボタンでメニューを閉じる（デリゲーション）
				$nav.addEventListener('click', (e) => {
					const closeBtn = e.target.closest('.js-header-nav-menu-close');
					if (!closeBtn) return;
					e.preventDefault();
					if ($nav.classList.contains(a)) {
						$nav.classList.remove(a);
						$hamburger.classList.remove(a);
						$hamburger.setAttribute('aria-expanded', 'false');
						$hamburger.ariaLabel = 'open';
						fixedOffContainer();
						$hamburger.focus({ preventScroll: true });
						$hamburgerText.textContent = "メニュー";
					}
				});

				// フォーカストラップとESCで閉じる
				window.addEventListener("keydown", function (event) {
					if ($nav.classList.contains(a)) {
						if (event.key === "Tab") {
							event.preventDefault();
							const focusableElementsSelector = 'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, [tabindex="0"], [contenteditable]';
							let focusableElements = Array.from($header.querySelectorAll(focusableElementsSelector))
								.filter(el => el.offsetParent !== null);
							if (!focusableElements.length) return;
							const focusedItemIndex = focusableElements.indexOf(document.activeElement);
							if (event.shiftKey) {
								(focusedItemIndex <= 0 ? focusableElements[focusableElements.length - 1] : focusableElements[focusedItemIndex - 1]).focus();
							} else {
								(focusedItemIndex === focusableElements.length - 1 ? focusableElements[0] : focusableElements[focusedItemIndex + 1]).focus();
							}
						}
						if (event.key === "Escape") {
							event.preventDefault();
							$nav.classList.remove(a);
							$hamburger.classList.remove(a);
							setAria(false);
							fixedOffContainer();
							$hamburger.focus({ preventScroll: true });
							$hamburgerText.textContent = "メニュー";
						}
					}
				});

				// リサイズでPC幅へ戻ったらメニューを閉じる
				window.addEventListener('resize', () => {
					if (window.innerWidth > 1024 && $nav.classList.contains(a)) {
						$nav.classList.remove(a);
						$hamburger.classList.remove(a);
						setAria(false);
						fixedOffContainer();
						$hamburgerText.textContent = "メニュー";
					}
				});
			}
		},
		snsHover() {
			// SNSアイコンのホバー時にSVGを切り替える
			const snsIcons = document.querySelectorAll('.js-sns-hover');
			
			snsIcons.forEach(icon => {
				const useElement = icon.querySelector('use');
				const originalIcon = icon.getAttribute('data-icon');
				const hoverIcon = originalIcon + '_hover';
				
				icon.addEventListener('mouseenter', () => {
					useElement.setAttribute('href', `/ladies/cnt_common/svg/sprite.svg#${hoverIcon}`);
				});
				
				icon.addEventListener('mouseleave', () => {
					useElement.setAttribute('href', `/ladies/cnt_common/svg/sprite.svg#${originalIcon}`);
				});
			});
		},
		footerGroupToggle() {
			// フッターグループリンクのトグル機能（1024px以下でのみ動作）
			const footerGroupTitle = document.querySelector('.footer-group-title');
			const footerGroupContent = document.querySelector('.js-spHidden');
			const footerGroup = document.querySelector('.footer-group');
			
			if (footerGroupTitle && footerGroupContent && footerGroup) {
				footerGroupTitle.addEventListener('click', () => {
					// 1024px以下でのみ動作させる
					if (window.innerWidth <= 1024) {
						// 現在の状態をチェック
						const isActive = footerGroupContent.classList.contains('is-active');
						
						if (isActive) {
							// スライドアップアニメーション
							const slideUp = footerGroupContent.animate(
								{
									opacity: [1, 0],
									height: [footerGroupContent.scrollHeight + 'px', '0px'],
									paddingTop: ['20px', '0px'],
									paddingBottom: ['0px', '0px']
								},
								{
									duration: 300,
									easing: 'ease-out'
								}
							);
							
							slideUp.addEventListener('finish', () => {
								footerGroupContent.classList.remove('is-active');
								footerGroup.classList.remove('is-group-active');
								footerGroupContent.style.height = '';
								footerGroupContent.style.paddingTop = '';
								footerGroupContent.style.paddingBottom = '';
							});
						} else {
							// まずクラスを追加してdisplay: blockにする
							footerGroupContent.classList.add('is-active');
							footerGroup.classList.add('is-group-active');
							
							// 高さを測定するために一時的に表示
							// footerGroupContent.style.height = 'auto';
							// const targetHeight = footerGroupContent.scrollHeight;
							// footerGroupContent.style.height = '0px';
							
							// スライドダウンアニメーション
							footerGroupContent.animate(
								{
									opacity: [0, 1],
									height: ['0px', targetHeight + 'px'],
									paddingTop: ['0px', '20px'],
									paddingBottom: ['0px', '0px']
								},
								{
									duration: 300,
									easing: 'ease-out'
								}
							).addEventListener('finish', () => {
								footerGroupContent.style.height = '';
								footerGroupContent.style.paddingTop = '';
								footerGroupContent.style.paddingBottom = '';
							});
						}
					}
				});
				
				// リサイズ時に1024pxを超えた場合はis-activeクラスを削除
				window.addEventListener('resize', () => {
					if (window.innerWidth > 1024) {
						footerGroupContent.classList.remove('is-active');
						footerGroup.classList.remove('is-group-active');
						// スタイルをリセット
						footerGroupContent.style.height = '';
						footerGroupContent.style.paddingTop = '';
						footerGroupContent.style.paddingBottom = '';
					}
				});
			}
		},
		// splide02のスライダーのみを初期化
		LineupSlide() {
			var splide02Element = document.querySelector('.splide02');
			if (splide02Element) {
				var splide02 = new Splide('.splide02', {
					type: 'loop',
					perPage: 1.25,
					perMove: 1,
					focus: 'center',
					pagination: true,
					arrows: false, // 矢印を無効にしてシンプルに
					gap: '1rem',
					autoplay: false,
					speed: 600,
					easing: 'ease',
					drag: true,
					breakpoints: {
						768: {
							perPage: 1.5,
							arrows: true,
							gap: '0.5rem',
						}
					}
				});
				try {
					splide02.mount();
					console.log('splide02 initialized successfully');
				} catch (error) {
					console.error('Error initializing splide02:', error);
				}
			}
		},
		// SPメニュー用アコーディオン（大項目＋小項目）
		headerMenuAccordion() {
			// 大項目（ブランドラインナップブロック）の開閉
			const spBlocks = document.querySelectorAll('.headerRn-nav-menu-sp');
			spBlocks.forEach((block, idx) => {
				const button = block.querySelector('.js-headerRn-nav-menu-sp-accordion-ttl');
				const content = block.querySelector('.js-headerRn-nav-menu-sp-accordion-block');
				if (!button || !content) return;

				// aria属性と対象IDの付与
				const contentId = content.id || `header-sp-acc-${idx}`;
				content.id = contentId;
				button.setAttribute('aria-controls', contentId);
				button.setAttribute('aria-expanded', 'false');

				// 初期はSPで閉じる is-openクラスがあれば開いた状態に
				if (window.innerWidth <= 1024) {
					if (block.classList.contains('is-open')) {
						content.style.display = 'block';
						button.setAttribute('aria-expanded', 'true');
					} else {
						block.classList.remove('is-open');
						content.style.display = 'none';
						button.setAttribute('aria-expanded', 'false');
					}				
				}

				button.addEventListener('click', (e) => {
					e.preventDefault();
					if (window.innerWidth > 1024) return;

					const willOpen = !block.classList.contains('is-open');
					if (willOpen) {
						block.classList.add('is-open');
						content.style.display = 'block';
						const h = content.scrollHeight;
						content.animate(
							{ height: ['0px', h + 'px'], opacity: [0, 1] },
							{ duration: 200, easing: 'ease-out' }
						).addEventListener('finish', () => {
							content.style.height = '';
							content.style.opacity = '';
						});
					} else {
						const h = content.scrollHeight;
						content.animate(
							{ height: [h + 'px', '0px'], opacity: [1, 0] },
							{ duration: 200, easing: 'ease-out' }
						).addEventListener('finish', () => {
							block.classList.remove('is-open');
							content.style.display = 'none';
							content.style.height = '';
							content.style.opacity = '';
						});
					}
					button.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
				});
			});

			// 小項目（オーダーメイド・ウィッグのサブアコーディオン）の開閉
			document.querySelectorAll('.headerRn-nav-menu-sp-accordion').forEach((item, idx) => {
				const btn = item.querySelector('.headerRn-nav-menu-sp-accordion-ttl');
				const inner = item.querySelector('.headerRn-nav-menu-sp-accordion-inner');
				if (!btn || !inner) return;

				const innerId = inner.id || `header-sp-subacc-${idx}`;
				inner.id = innerId;
				btn.setAttribute('aria-controls', innerId);

				// 初期はSPで閉じる is-openクラスがあれば開いた状態に
				if (window.innerWidth <= 1024) {
					if (item.classList.contains('is-open')) {
						inner.style.display = 'block';
						btn.setAttribute('aria-expanded', 'true');
					} else {
						item.classList.remove('is-open');
						inner.style.display = 'none';
						btn.setAttribute('aria-expanded', 'false');
					}				
				}

				btn.addEventListener('click', (e) => {
					e.preventDefault();
					if (window.innerWidth > 1024) return;

					const willOpen = !item.classList.contains('is-open');
					if (willOpen) {
						item.classList.add('is-open');
						inner.style.display = 'block';
						const h = inner.scrollHeight;
						inner.animate(
							{ height: ['0px', h + 'px'], opacity: [0, 1] },
							{ duration: 200, easing: 'ease-out' }
						).addEventListener('finish', () => {
							inner.style.height = '';
							inner.style.opacity = '';
						});
					} else {
						const h = inner.scrollHeight;
						inner.animate(
							{ height: [h + 'px', '0px'], opacity: [1, 0] },
							{ duration: 200, easing: 'ease-out' }
						).addEventListener('finish', () => {
							item.classList.remove('is-open');
							inner.style.display = 'none';
							inner.style.height = '';
							inner.style.opacity = '';
						});
					}
					btn.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
				});
			});

			// リサイズ時の状態調整
			window.addEventListener('resize', () => {
				document.querySelectorAll('.headerRn-nav-menu-sp').forEach((block) => {
					const content = block.querySelector(':scope > ul.mod-column');
					const button = block.querySelector('[data-view="sp"] > .headerRn-nav-menu-large');
					if (!content || !button) return;

					if (window.innerWidth > 1024) {
						block.classList.remove('is-open');
						content.style.display = '';
						button.setAttribute('aria-expanded', 'false');
					} else if (!block.classList.contains('is-open')) {
						content.style.display = 'none';
					}
				});

				document.querySelectorAll('.headerRn-nav-menu-sp-accordion').forEach((item) => {
					const inner = item.querySelector('.headerRn-nav-menu-sp-accordion-inner');
					const btn = item.querySelector('.headerRn-nav-menu-sp-accordion-ttl');
					if (!inner || !btn) return;

					if (window.innerWidth > 1024) {
						inner.style.display = '';
						btn.setAttribute('aria-expanded', 'false');
						item.classList.remove('is-open');
					} else if (!item.classList.contains('is-open')) {
						inner.style.display = 'none';
					}
				});
			});
		},
		// 追加: SP/タブレットでスクロール時に固定メニューを下部から表示
		fixedSpMenu() {
			const menu = document.querySelector('.ladies-rn-fixedMenu');
			if (!menu) return;

			const isSpTab = () => window.innerWidth <= 1024;
			const show = () => { menu.classList.add('is-active'); menu.classList.add('is-visible'); };
			const hide = () => { menu.classList.remove('is-active'); menu.classList.remove('is-visible'); };

			// 追記: フッターが見えたら非表示
			const footer = document.querySelector('.inc_common_footer') || document.querySelector('footer');
			const footerInView = () => {
				if (!footer) return false;
				const top = footer.getBoundingClientRect().top;
				return top <= window.innerHeight; // フッターの上端がビューポート内に入ったらtrue
			};

			// 表示しきい値(px)
			const threshold = 80;

			const update = () => {
				if (!isSpTab()) {
					hide();
					return;
				}
				// 追記: フッター可視時は常に非表示
				if (footerInView()) {
					hide();
					return;
				}
				if (window.scrollY > threshold) {
					show();
				} else {
					hide();
				}
			};

			// rAFでスクロールをスロットル
			let ticking = false;
			const onScroll = () => {
				if (ticking) return;
				ticking = true;
				requestAnimationFrame(() => {
					update();
					ticking = false;
				});
			};

			// 初期状態反映
			update();

			// イベント登録
			window.addEventListener('scroll', onScroll, { passive: true });
			window.addEventListener('resize', update);
		},
		setTicker() {
			// vanilla JS JSONP（jQuery/slick不使用）
			const callbackName = `__ladiesNewsCB_${Date.now()}`;
			const url = new URL('https://www.shop-salon.jp/ajax/newsrelease/ladies.json');
			url.searchParams.set('news_list', callbackName);

			const script = document.createElement('script');
			const cleanup = () => {
				try { delete window[callbackName]; } catch (e) { window[callbackName] = undefined; }
				if (script && script.parentNode) script.parentNode.removeChild(script);
			};

			window[callbackName] = (data) => {
				try {
					const list = (data && data.news_list && data.news_list[0] && data.news_list[0].cf_ng_news) ? data.news_list[0].cf_ng_news : [];
					const items = list.slice(0, 3); // 先頭3件
					const esc = (s) => s == null ? '' : String(s)
						.replace(/&/g, '&amp;')
						.replace(/</g, '&lt;')
						.replace(/>/g, '&gt;')
						.replace(/"/g, '&quot;')
						.replace(/'/g, '&#39;');

					// ここを変更: ulを複製せず、liを複製
					let listItemsHtml = '';
					for (let i = 0; i < items.length; i++) {
						const item = items[i];
						const d = new Date(item.cf_n_date);
						const yyyy = d.getFullYear();
						const m = d.getMonth() + 1;
						const dd = d.getDate();
						const href = item.cf_n_url ? item.cf_n_url : `/newsrelease/detail/${item._key}.html`;
						const activeClass = i === 0 ? ' is-active is-visible' : '';
						const hiddenAttr = i === 0 ? '' : ' hidden aria-hidden="true"';

						listItemsHtml += `<li class="${activeClass.trim()}"${hiddenAttr}><a href="${href}" class="opacity" target="_new"><span class="__day">${yyyy}/${m}/${dd}</span><span class="__ttl">${esc(item.cf_n_title)}</span></a></li>`;
					}
					const ladiesHtml = `<ul class="__contents">${listItemsHtml}</ul>`;

					const container = document.querySelector('.js-ticker-ladies');
					if (container) {
						container.innerHTML = ladiesHtml;
					}
					// slickは未使用。見た目のフラグのみ合わせる
					document.querySelectorAll('.js-ticker').forEach(el => el.classList.add(a));
				} catch (err) {
					console.log('ladies2', err);
				} finally {
					cleanup();
				}
			};

			script.src = url.toString();
			script.onerror = (err) => {
				console.log('ladies2', err);
				cleanup();
			};
			document.head.appendChild(script);
		},
		dropdownMenu() {
			const dropdowns = document.querySelectorAll('.mod-dropdown');
			
			dropdowns.forEach(dropdown => {
				const toggle = dropdown.querySelector('.mod-dropdown-toggle');
				const menu = dropdown.querySelector('.mod-dropdown-menu');
				
				if (toggle && menu) {
					// ドロップダウントグルのクリックイベント
					toggle.addEventListener('click', (e) => {
						e.preventDefault();
						e.stopPropagation();
						
						// 他のドロップダウンを閉じる
						dropdowns.forEach(otherDropdown => {
							if (otherDropdown !== dropdown) {
								otherDropdown.classList.remove('is-open');
							}
						});
						
						// 現在のドロップダウンを切り替え
						dropdown.classList.toggle('is-open');
					});
					
					// メニュー内のリンククリック時は閉じる
					const menuLinks = menu.querySelectorAll('a');
					menuLinks.forEach(link => {
						link.addEventListener('click', () => {
							dropdown.classList.remove('is-open');
						});
					});
				}
			});
			
			// 外側クリックで全ドロップダウンを閉じる
			document.addEventListener('click', (e) => {
				if (!e.target.closest('.mod-dropdown')) {
					dropdowns.forEach(dropdown => {
						dropdown.classList.remove('is-open');
					});
				}
			});
			
			// ESCキーで全ドロップダウンを閉じる
			document.addEventListener('keydown', (e) => {
				if (e.key === 'Escape') {
					dropdowns.forEach(dropdown => {
						dropdown.classList.remove('is-open');
					});
				}
			});
		},
		helpfeelTwoTap() {
			const wrap = document.querySelector('.helpfeel-content');
			if (!wrap) return;
			const link = wrap.querySelector('a');
			if (!link) return;

			let open = false;
			const openPanel = () => {
				wrap.classList.add('is-open');
				open = true;
				link.setAttribute('aria-expanded', 'true');
			};
			const closePanel = () => {
				wrap.classList.remove('is-open');
				open = false;
				link.setAttribute('aria-expanded', 'false');
			};

			// 初期状態
			link.setAttribute('aria-expanded', 'false');

			// 1回目タップで展開、2回目で遷移
			link.addEventListener('click', (e) => {
				if (!open) {
					e.preventDefault();
					openPanel();
				}
				// open時は通常遷移
			});

			// 外側クリックで閉じる
			document.addEventListener('click', (e) => {
				if (!wrap.classList.contains('is-open')) return;
				if (wrap.contains(e.target)) return;
				closePanel();
			});

			// Escで閉じる
			document.addEventListener('keydown', (e) => {
				if (e.key === 'Escape') closePanel();
			});

			// リサイズで閉じる
			window.addEventListener('resize', closePanel);
		},
		voiceSlide01() {
			const splide01 = document.querySelectorAll('.mod-slider-voice-slider01')
			splide01.forEach(slide => {
				new Splide(slide, {
					destroy: true,
					type: 'loop',
					perPage: 3,
					autoplay: true,
					gap: '8px',
					interval: 5000,
					speed: 500,
					arrows: true,
					pagination: true,
					paginationKeyboard: true,
					breakpoints: {
						1024: {
							destroy: false,
							focus: 'center', 
							perPage: 1.5,
							gap: '8px',
						},
					},
				}).mount();
			});
		},
		voiceSlide02() {
			const splide02 = document.querySelectorAll('.mod-slider-voice-slider02')
			splide02.forEach(slide => {
				new Splide(slide, {
					type: 'loop',
					perPage: 4.5,
					autoplay: true,
					gap: '8px',
					interval: 5000,
					speed: 500,
					perMove: 1,
					arrows: true,
					pagination: true,
					paginationKeyboard: true,
					breakpoints: {
						1024: {
							focus: 'center',
							perPage: 1.5,
							gap: '8px',
						},
					},
				}).mount();
			});
		},
		voiceAccordion() {
			const accordions = document.querySelectorAll('[data-voice-accordion]');
		
			accordions.forEach(accordion => {
				const toggleBtn = accordion.querySelector('.mod-voice-accordion-toggle');
				const content = accordion.querySelector('.mod-voice-accordion-content');
				const preview = accordion.querySelector('.mod-voice-accordion-preview');
				const toggleText = accordion.querySelector('.toggle-text');
				const plus = accordion.querySelector('.mod-voice-accordion-plus');

				if (toggleBtn && content && preview && toggleText && plus) {
					// 初期設定：previewとcontentのテキストを結合
					const previewText = preview.querySelector('p').innerHTML;
					const contentText = content.querySelector('p').innerHTML;
					const fullText = previewText + contentText;

					// previewのpタグに結合したテキストを設定
					const combinedP = preview.querySelector('p');
					combinedP.innerHTML = fullText;

					// contentを非表示に
					content.style.display = 'none';

					// fullTextの行数をチェックして3行以内ならtoggleBtnを非表示
					requestAnimationFrame(() => {
						// 一時的にline-clampを解除して正確な高さを測定
						const originalLineClamp = combinedP.style.webkitLineClamp;
						const originalDisplay = combinedP.style.display;
						const originalBoxOrient = combinedP.style.webkitBoxOrient;
						const originalOverflow = combinedP.style.overflow;
						
						combinedP.style.webkitLineClamp = 'unset';
						combinedP.style.display = 'block';
						combinedP.style.webkitBoxOrient = 'initial';
						combinedP.style.overflow = 'visible';
						
						const lineHeight = parseFloat(getComputedStyle(combinedP).lineHeight);
						const height = combinedP.getBoundingClientRect().height;
						const lineCount = Math.round(height / lineHeight);
						
						// スタイルを元に戻す
						combinedP.style.webkitLineClamp = originalLineClamp || '3';
						combinedP.style.display = originalDisplay || '-webkit-box';
						combinedP.style.webkitBoxOrient = originalBoxOrient || 'vertical';
						combinedP.style.overflow = originalOverflow || 'hidden';
						
						if (lineCount <= 3) {
							toggleBtn.style.display = 'none';
						}
					});

					toggleBtn.addEventListener('click', () => {
						const isOpen = accordion.classList.contains('is-open');

						if (isOpen) {
							// 閉じる処理
							accordion.classList.remove('is-open');
							toggleText.textContent = '続きを見る';
							plus.classList.remove('is-open');

							// previewのpタグをクランプ表示に戻す
							combinedP.style.webkitLineClamp = '3';
							combinedP.style.display = '-webkit-box';
							combinedP.style.webkitBoxOrient = 'vertical';
							combinedP.style.overflow = 'hidden';
						} else {
							// 開く処理
							accordion.classList.add('is-open');
							toggleText.textContent = '閉じる';
							plus.classList.add('is-open');

							// previewのpタグを全文表示
							combinedP.style.webkitLineClamp = 'unset';
							combinedP.style.display = 'block';
							combinedP.style.overflow = 'visible';
						}
					});
				}
			});
		},
		scrollImg() {
			if (document.querySelector('.js-scrollable')) {
				new ScrollHint('.js-scrollable', {
					suggestiveShadow: false,
					i18n: {
						scrollable: "スクロール<br>できます"
					}
				});
			}
		},
		loadDelayScript() {
			let _this = this;
			_this.accordion();
			_this.tabSwitch();
			_this.easeScroll();
			_this.easeScrollHash();
			_this.pageTop();
			_this.setModal();
			_this.matchHeight();
			_this.inViewAnimation();
			_this.fileSize();
			_this.removeElmIfEmpty();
			_this.removeBlockIfListEmpty();
			_this.URLcurrent();
			_this.URLcurrentHidden();
			_this.snsHover();
			_this.footerGroupToggle();
			_this.LineupSlide();
			_this.headerHamburger();
			_this.headerMenuAccordion();
			_this.fixedSpMenu();
			_this.setTicker();
			_this.dropdownMenu();
			_this.helpfeelTwoTap();
			_this.voiceSlide01();
			_this.voiceSlide02();
			_this.voiceAccordion();
			_this.scrollImg();

			let resizeTime = 0;
			window.addEventListener('resize', () => {
				clearTimeout(resizeTime);
				resizeTime = setTimeout(() => {
					_this.matchHeight();
				}, 300);
			});
		}
	};

	document.addEventListener('DOMContentLoaded', () => FUNCTIONS.localDecision() ? FUNCTIONS.localLoading() : FUNCTIONS.loadDelayScript());
})();
